import classNames from "classnames";
import "./index.scss";

interface IProps {
  onClick?: () => void;
  style?: string;
}

export const StudyPlannerPlusIcon = ({ onClick, style }: IProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames({
        "study-planner-plus-icon": true,
        [`${style}`]: style,
      })}
    >
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 0.5C3.3675 0.5 0 3.8675 0 8C0 12.1325 3.3675 15.5 7.5 15.5C11.6325 15.5 15 12.1325 15 8C15 3.8675 11.6325 0.5 7.5 0.5ZM10.5 8.8625H8.3625V9.93125V11C8.3625 11.3075 8.15217 11.8625 7.5 11.8625C6.84783 11.8625 6.6375 11.3075 6.6375 11V9.93125V8.8625H4.5C4.1925 8.8625 3.6375 8.65217 3.6375 8C3.6375 7.34783 4.1925 7.1375 4.5 7.1375H6.6375V5C6.6375 4.6925 6.84783 4.25 7.5 4.25C8.15217 4.25 8.3625 4.6925 8.3625 5V6.21875V7.1375H10.5C10.8075 7.1375 11.3625 7.34783 11.3625 8C11.3625 8.65217 10.8075 8.8625 10.5 8.8625Z"
          fill="#006EB3"
        />
      </svg>
    </div>
  );
};
